import type { NavigationState } from '@/stores/navigation-store'
import type { DashboardMetrics } from '@vizible/api'
import type { StateCreator } from 'zustand'

export interface MetricsSlice {
    // State
    searchMetrics: Record<string, DashboardMetrics | null>

    // Actions
    setSearchMetrics: (searchId: string, metrics: DashboardMetrics | null) => void
    resetDashboardData: (searchId: string) => void
    getSearchMetrics: (searchId: string) => DashboardMetrics | null
}

export const createMetricsSlice: StateCreator<NavigationState & MetricsSlice, [], [], MetricsSlice> = (set, get) => ({
    // Initial state
    searchMetrics: {},

    setSearchMetrics: (searchId, metrics) => {
        set(state => ({
            searchMetrics: {
                ...state.searchMetrics,
                [searchId]: metrics,
            },
        }))
    },

    resetDashboardData: searchId => {
        set(state => {
            const newMetrics = { ...state.searchMetrics }
            delete newMetrics[searchId]
            return {
                searchMetrics: newMetrics,
            }
        })
    },

    getSearchMetrics: searchId => {
        return get().searchMetrics[searchId] || null
    },
})
